import 'rxjs';
import { Observable } from 'rxjs/Observable';
import actions, { LOAD_SUBSCRIPTIONS } from '../actions';

const loadSubscriptionsEpic = (action$, store, { api }) =>
    action$.ofType(LOAD_SUBSCRIPTIONS).mergeMap(action =>
        Observable.from(api.fetchSubscriptions(action.payload))
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            .map(response => toAction(response))
            .catch(() =>
                Observable.of(
                    actions.subscriptionsFailure('Problem loading shifts'),
                ),
            ),
    );

const toAction = response => {
    if (response) {
        return actions.subscriptionsSuccess(response.data);
    }
    return actions.subscriptionsFailure('Problem loading shifts');
};

export default loadSubscriptionsEpic;
